import React, { useState } from 'react';
import { auth } from '../firebase';
import { useNotifications } from '../hooks/notificationsContext';

const NewsComposer = () => {
  const { addNotification } = useNotifications();
  const [headline, setHeadline] = useState("");
  const [content, setContent] = useState("");
  const [type, setType] = useState("info");
  const [isSending, setIsSending] = useState(false);

const handlePublish = async () => {
  if (!headline || !content) {
    addNotification("Headline and Content are required.", "error");
    return;
  }

  setIsSending(true);

  try {
    const token = await auth.currentUser.getIdToken();
    const response = await fetch("https://postnewsupdate-5dhfwyjvzq-uc.a.run.app", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        headline,
        content,
        type,
        UID: auth.currentUser.uid
      }),
    });

    if (response.ok) {
      const data = await response.json();
      addNotification(data.status, "success");
      setHeadline("");
      setContent("");
    } else {
      const errorText = await response.text();
      addNotification(`Uplink Denied: ${errorText}`, "error");
    }
  } catch (err) {
    console.error(err);
    addNotification("Network Error: Failed to contact Uplink.", "error");
  } finally {
    setIsSending(false);
  }
};

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>NEWS TERMINAL</h2>
      
      <input 
        style={styles.input}
        placeholder="HEADLINE"
        value={headline}
        onChange={(e) => setHeadline(e.target.value)}
      />

<select style={styles.select} value={type} onChange={(e) => setType(e.target.value)}>
        <option value="general">GENERAL (Teal)</option>
        <option value="game update">GAME UPDATE (Gold)</option>
        <option value="market">MARKET (Blue)</option>
        <option value="community">COMMUNITY (Orange)</option>
        <option value="event">EVENT (Purple)</option>
      </select>

      <textarea 
        style={styles.textarea}
        placeholder="Write content in Markdown... Use * for bullets and ** for bold."
        value={content}
        onChange={(e) => setContent(e.target.value)}
        rows={6}
      />

      <button 
        onClick={handlePublish} 
        disabled={isSending}
        style={{...styles.button, opacity: isSending ? 0.5 : 1}}
      >
        {isSending ? "POSTING..." : "POST"}
      </button>
    </div>
  );
};

const styles = {
container: { 
    backgroundColor: '#0a1010', 
    opacity: '1 !important',
    border: '2px solid #50e3c2', 
    overflow: 'hidden', 

    padding: '24px', 
    borderRadius: '8px', 
    maxWidth: '500px', 
    width: '90vw', 
    fontFamily: 'JetBrains Mono, monospace',
    boxShadow: '0 0 50px #000000, 0 0 20px rgba(80, 227, 194, 0.3)',
    position: 'relative',
    zIndex: 10001,
    boxSizing: 'border-box'
  },
  title: { 
    color: '#50e3c2', 
    fontSize: '16px', 
    marginTop: '0', 
    marginBottom: '20px', 
    letterSpacing: '2px',
    borderBottom: '1px solid #50e3c233',
    paddingBottom: '10px'
  },
  input: { 
    width: '100%', 
    background: '#000', 
    border: '1px solid #50e3c266', 
    color: '#fff', 
    padding: '12px', 
    marginBottom: '15px', 
    outline: 'none',
    boxSizing: 'border-box',
    fontSize: '14px'
  },
  select: { 
    width: '100%', 
    background: '#000', 
    border: '1px solid #50e3c266', 
    color: '#50e3c2', 
    padding: '10px', 
    marginBottom: '15px',
    boxSizing: 'border-box',
    cursor: 'pointer'
  },
  textarea: { 
    width: '100%', 
    background: '#000', 
    border: '1px solid #50e3c266', 
    color: '#fff', 
    padding: '12px', 
    marginBottom: '20px', 
    outline: 'none', 
    resize: 'none',
    boxSizing: 'border-box',
    fontSize: '13px',
    lineHeight: '1.5'
  },
  button: { 
    width: '100%', 
    background: '#50e3c2',
    border: 'none', 
    color: '#080d0d',
    padding: '14px', 
    cursor: 'pointer', 
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    transition: 'all 0.2s ease'
  }
};

export default NewsComposer;